import { Injectable } from '@angular/core';
import { IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '../models/features.enum';

/**
 * Flag to disabling/enabling showing custom spacing in selectors for orders from omnichannel for offline orders
 * @see https://cemexpmo.atlassian.net/browse/CX030GO2103-18746
 */
@Injectable()
export class CustomSpacingFeature implements IFlagFeature {
  name: string = Features.CUSTOM_SPACING;

  public isEnabled(container?: IToggleContainer): boolean {
    return container[this.name].isEnabled();
  }
}
